import { computed, Service, signal } from '@angular/core';

export interface AuthenticatedUser {
  username: string;
  email: string;
  name: string;
  firstName?: string;
  lastName?: string;
  roles: string[];
}

@Service()
export class AuthState {
  private readonly _user = signal<AuthenticatedUser | null>(null);

  readonly user = this._user.asReadonly();
  readonly isAuthenticated = computed(() => this._user() !== null);
  readonly displayName = computed(() => this._user()?.name ?? '');
  readonly roles = computed(() => this._user()?.roles ?? []);

  setUser(user: AuthenticatedUser): void {
    this._user.set(user);
  }

  clear(): void {
    this._user.set(null);
  }
}
